import { DARK_THEME } from "../../../styles/const.theme.ts";
import { IconMoonStars, IconSunset2Filled } from "@tabler/icons-react";
import ThemeController from "./controller/ThemeController";

const ThemeToggle = ({
  size = 28,
  className,
  textLight,
  textDark,
}: {
  size?: number;
  className?: string;
  textLight?: string;
  textDark?: string;
}) => {
  const showText = textLight !== undefined || textDark !== undefined;
  return (
    <ThemeController>
      {(changeTheme, currentTheme) => (
        <button
          onClick={changeTheme}
          aria-label={showText ? undefined : "Theme umschalten"}
          className={`inline-flex items-center gap-2 ${className ?? ""}`.trim()}
        >
          <label className="swap swap-rotate leading-none">
            <input
              type="checkbox"
              defaultValue={DARK_THEME}
              checked={currentTheme === DARK_THEME}
              readOnly
            />
            <IconSunset2Filled size={size} className="swap-off" />
            <IconMoonStars size={size} className="swap-on" />
          </label>
          {showText && (
            <label className="swap leading-none">
              <input
                type="checkbox"
                defaultValue={DARK_THEME}
                checked={currentTheme === DARK_THEME}
                readOnly
              />
              <p className="swap-off">{textLight}</p>
              <p className="swap-on">{textDark}</p>
            </label>
          )}
        </button>
      )}
    </ThemeController>
  );
};
export default ThemeToggle;
